export const environment = {
  BASE_URL: 'https://maxroteirizador-svc-tst.solucoesmaxima.com.br/maxroteirizador-service',
  production: false,
  CHAVE_GOOGLE_MAPS: 'AIzaSyBL0jq_t_-GYgps-ZKhuwqKuCuOVkhdhiw',
  baseHref: 'v1',
  maxHelpScriptUrl: 'https://sabidinho-chat-client-hmg.solucoesmaxima.com.br/maxhelp-wc.js',
  maxInsightsUrl: 'https://maxinsights-hmg.solucoesmaxima.com.br'
};
